/**
 * Created by Ning Jiang on 2023-08-31.
 */

import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DevilsCrossRoadLayers, Layers} from "../../../view/DevilsCrossRoadLayers";
import {DevilsCrossRoad} from "../../../DevilsCrossRoad";
import {gsap, TimelineLite} from "gsap";
import {BetWayWinData} from "../../../server/data/DCRoadData";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {DevilsCrossRoadGameAssets} from "../../../DevilsCrossRoadGameAssets";
import {DCRoadReelsController} from "../../../reels/DCRoadReelsController";

export class IndividualWinText extends PIXI.Container {

    private _maxWayWidth:number = 280;

    constructor(betWayWin:BetWayWinData) {
        super();
        // winAmount = 10000000000000;
        // way = 11216;
        const baseNumber = betWayWin.multiplier === 1 ? betWayWin.multipliedAmount : MathHelper.roundToDecimals(betWayWin.multipliedAmount / betWayWin.multiplier, 2);
        const winNumber = new PIXI.BitmapText(`${SlotGame.apiPlugin.currency.formatValue(baseNumber)}${betWayWin.multiplier === 1 ? "" : `X${betWayWin.multiplier}`}`, {
            fontName : DevilsCrossRoadGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 50,
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        winNumber.letterSpacing = -24;
        (<PIXI.Point>winNumber.anchor).set(0.5, 0);
        winNumber.y = -20;
        this.addChild(winNumber);
        winNumber.updateTransform();
        if(winNumber.width > this._maxWayWidth) {
            const scale = MathHelper.roundToDecimals(this._maxWayWidth / winNumber.width, 2);
            winNumber.scale.set(scale);
        }
    }
}

export class InitialWinView {

    private _layer:StageLayer;

    constructor() {
        this._layer = DevilsCrossRoadLayers.getLayer(Layers.WIN_PRESENTATIONS)!;
    }

    public playWinText(betWayWin:BetWayWinData):TimelineLite {
        const winText = new IndividualWinText(betWayWin!);
        // TODO: check all dewWay if contains W then use the first not wild symbol position.
        const innerCoord = DCRoadReelsController.DEV_WAY_COORDS[betWayWin.devWay][0];
        const innerSymbol = DevilsCrossRoad.reels.getSymbol(innerCoord[0], innerCoord[1])!
        let position:PIXI.Point;
        // if(innerSymbol.symbolName === "W") {
        //     const firstCoord = DCRoadReelsController.DEV_WAY_COORDS[betWayWin.devWay].find(c => {
        //         const s = DevilsCrossRoad.reels.getSymbol(c[0], c[1]);
        //         if(s && s.symbolName === betWayWin.symbol) {
        //             position = s.getGlobalPosition();
        //             return true
        //         }
        //         return false;
        //     });
        // } else {
            position = innerSymbol.getGlobalPosition();
        // }
        winText.position.set(position!.x, position!.y);
        winText.alpha = 0;
        DevilsCrossRoadLayers.getLayer(Layers.WIN_COUNT_UP)!.addChild(winText);
        const tl = gsap.timeline();
        const textTl = gsap.timeline({paused : true});
        textTl.add(gsap.to(winText, {alpha : 1, duration : 0.2}));
        textTl.add(gsap.to(winText, {y : winText.y - 80, duration : 0.8}));
        textTl.add(gsap.to(winText, {alpha : 0, duration : 0.1}));
        textTl.add(() => {
            winText.parent.removeChild(winText);
            winText.destroy();
        });
        tl.add(() => {textTl.play()});
        return tl;
    }
}